/**
 * Data visualization: Teal colors
 */
export var teal10 = '#a6fbfb';
export var teal20 = '#71f3f3';
export var teal30 = '#4be8e8';
export var teal40 = '#33d8d8';
export var teal40opacity20solidDark = '#284e54';
export var teal50 = '#22c2c2';
export var teal60 = '#17a3a3';
export var teal60opacity20solid = '#d1eded';
export var teal60opacity20solidDark = '#224449';
export var teal70 = '#0f8484';
export var teal80 = '#0a6161';
export var teal80opacity20solid = '#cedfdf';
